import { g as n } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { openBlock as r, createElementBlock as o, normalizeClass as s, createElementVNode as e } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const f = {
  name: "DtIconGoogleSlides",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(i).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = n();
  }
}, p = ["aria-label", "data-qa", "aria-hidden"], m = ["fill"], g = ["id"];
function h(a, l, d, v, A, t) {
  return r(), o("svg", {
    "aria-label": d.ariaLabel,
    class: s([t.iconSizeClass, "d-icon d-icon--google-slides"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Google Slides",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    l[1] || (l[1] = e("path", {
      d: "M5.5 1A1.5 1.5 0 0 0 4 2.5v19A1.5 1.5 0 0 0 5.5 23h13a1.5 1.5 0 0 0 1.5-1.5V7l-6-6H5.5Z",
      fill: "#F4B70A"
    }, null, -1)),
    l[2] || (l[2] = e("path", {
      d: "M5.5 23A1.5 1.5 0 0 1 4 21.5v-.25a1.5 1.5 0 0 0 1.5 1.5h13a1.5 1.5 0 0 0 1.5-1.5v.25a1.5 1.5 0 0 1-1.5 1.5h-13Z",
      fill: "#EFA904"
    }, null, -1)),
    l[3] || (l[3] = e("path", {
      d: "M5.5 1A1.5 1.5 0 0 0 4 2.5v.25a1.5 1.5 0 0 1 1.5-1.5h8.75L14 1H5.5Z",
      fill: "#F6C028"
    }, null, -1)),
    e("path", {
      d: "M20 12.125V7l-.875-.875h-4.22a.375.375 0 0 0-.265.64l5.36 5.36Z",
      fill: `url(#${a.uniqueID}a)`
    }, null, 8, m),
    l[4] || (l[4] = e("path", {
      d: "m14 1 6 6h-4.5A1.5 1.5 0 0 1 14 5.5V1Z",
      fill: "#FADC87"
    }, null, -1)),
    l[5] || (l[5] = e("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8.5 11a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5h-7Zm6.5 2.25H9v3.5h6v-3.5Z",
      fill: "#fff"
    }, null, -1)),
    e("defs", null, [
      e("linearGradient", {
        id: `${a.uniqueID}a`,
        x1: "17.265",
        y1: "12.125",
        x2: "17.265",
        y2: "6",
        gradientUnits: "userSpaceOnUse"
      }, [...l[0] || (l[0] = [
        e("stop", { "stop-color": "#F4B70A" }, null, -1),
        e("stop", {
          offset: "1",
          "stop-color": "#E2930A"
        }, null, -1)
      ])], 8, g)
    ])
  ], 10, p);
}
const b = /* @__PURE__ */ u(f, [["render", h]]);
export {
  b as default
};
//# sourceMappingURL=google-slides.js.map
